<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                id="select-manager"
                label="Менеджер"
                label-for="manager"
            >
                <b-form-select v-model="item.manager_id">
                    <b-form-select-option id="manager" :key="index" :value="manager.id" v-for="(manager, index) in managers" >{{ manager.name }}</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                id="select-role"
                label="Роль"
                label-for="role"
            >
                <b-form-select v-model="item.role">
                    <b-form-select-option id="role" :key="index" :value="role.name" v-for="(role, index) in roles" >{{ role.name_ru }}</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                    id="input-name"
                    label="ФИО"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="name"
                        v-model="item.name"
                        type="text"
                        placeholder="Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-company"
                label="Наименование компании"
                label-for="company"
                description=""
            >
                <b-form-input
                    id="company"
                    v-model="item.company"
                    type="text"
                    placeholder="Company"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-bin"
                label="БИН"
                label-for="bin"
                description=""
            >
                <b-form-input
                    id="bin"
                    v-model="item.bin"
                    type="text"
                    placeholder="Bin"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-legal-address"
                    label="Юридический адрес:"
                    label-for="legal-address"
                    description=""
            >
                <b-form-input
                        id="legal-address"
                        v-model="item.legal_address"
                        type="text"
                        placeholder="Юридический адрес"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-iik"
                    label="ИИК"
                    label-for="iik"
                    description=""
            >
                <b-form-input
                        id="iik"
                        v-model="item.iik"
                        type="text"
                        placeholder="ИИК"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-bik"
                    label="БИК"
                    label-for="bik"
                    description=""
            >
                <b-form-input
                        id="bik"
                        v-model="item.bik"
                        type="text"
                        placeholder="БИК"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-bank"
                    label="Наименование банка"
                    label-for="bank"
                    description=""
            >
                <b-form-input
                        id="bank"
                        v-model="item.bank_name"
                        type="text"
                        placeholder="Наименование банка"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-phone"
                    label="Телефон"
                    label-for="phone"
                    description=""
            >
                <b-form-input
                        id="phone"
                        v-model="item.phone"
                        type="text"
                        placeholder="Телефон"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-email"
                    label="E-mail"
                    label-for="email"
            >
                <b-form-input
                        id="email"
                        v-model="item.email"
                        type="email"
                        placeholder="E-mail"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-comment"
                    label="Комментарий"
                    label-for="comment"
            >
                <b-form-input
                        id="comment"
                        v-model="item.comment"
                        type="email"
                        placeholder="Comment"
                        disabled
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-resident"
                    label="Не резидент РК"
                    label-for="resident"
            >
                <b-form-input
                        id="resident"
                        v-model="item.residents == true ? 'Да' : 'Нет'"
                        type="test"
                        placeholder="No resident"
                        disabled
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="select-products"
                label="Скрыть товары от клиента"
                label-for="product"
                v-slot="{ ariaDescribedby }"
            >
                <b-form-checkbox-group
                    id="checkbox-group-products"
                    v-model="selected"
                    :options="options"
                    name="hidden_products"
                    :aria-describedby="ariaDescribedby"
                    stacked
                    @change="hidden()"
                ></b-form-checkbox-group>
            </b-form-group>

            <p v-if="item.image">
                <img :src="this.axios.defaults.baseImageURL + item.image" class="image-cart" alt="">
            </p>
            <input type="file" id="image" ref="image" v-on:change="handleFileUpload()"/>

            <div v-if="errors" v-for="error in errors" style="margin-top: 25px;">
                <div class="div" v-if="Array.isArray(error)">
                    <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
                </div>
                <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>

            </div>

            <div class="buttons">
                <b-button type="submit">Обновить</b-button>
            </div>
        </b-form>

        <manager-histories
            :user_id="this.$route.params.id"
        >

        </manager-histories>
    </div>
</template>

<script>
    import managerHistories from '../histories/Index'
    export default {
        data() {
            return {
                item: {},
                products: [],
                image: null,
                errors: [],
                managers: {},
                roles: {},
                loading: false,
                options: [],
                selected: [],
                hidden_products: []
            }
        },

        mounted() {
            this.axios
                .get(this.axios.defaults.baseURL + 'products')
                .then(response => {
                    for(let prod in response.data.products) {
                        this.selected.push(response.data.products[prod].id)
                        this.products.push(response.data.products[prod].id)

                        this.options.push({
                            'text': response.data.products[prod].name,
                            'value': response.data.products[prod].id
                        })
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
                this.selected = this.selected.filter( ( el ) => !this.hidden_products.includes( el ) )
                console.log(this.selected)
            })

            if (this.$route.params.id) {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/users/' + this.$route.params.id)
                    .then(response => {
                        this.item = response.data.user

                        if(this.item.hidden_products !== null) {
                            this.hidden_products = JSON.parse(this.item.hidden_products)
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false
                })
            }

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/managers')
                .then(response => {
                    this.managers = response.data.managers;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/roles')
                .then(response => {
                    this.roles = response.data.roles;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })
        },

        methods: {

            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.item.name) this.errors.push("ФИО обязателен.");
                if(!this.item.email) this.errors.push("Email обязателен.");
                if(!this.item.phone) this.errors.push("Номер обязателен.");
            },
            
            hidden: function() {
                this.hidden_products = this.products.filter((el) => !this.selected.includes( el ))
            },

            onSubmit(e){
                this.checkForm(e)
                e.preventDefault();
                this.item.hidden_products = this.hidden_products.length > 0 ? this.hidden_products : null
                let formData = new FormData();
                formData.append('item', JSON.stringify(this.item));
                formData.append('image', this.image);
                formData.append('_method', 'PUT');

                if (this.errors.length === 0){
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/users/' + this.$route.params.id, formData)
                        .then(response => {
                            if (response.data.message === 'success') {
                                this.$router.push({name: 'AdminUsers', params: {message: 'Пользователь успешно обновлен'}})
                            }else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            handleFileUpload() {
                this.image = this.$refs.image.files[0];
            }
        },

        components:{
            'manager-histories': managerHistories
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/users/edit.vue